import { HelmetProvider } from "react-helmet-async";
import { LazyMotion, domAnimation, MotionConfig } from "framer-motion";
import useLenis from "@/hooks/useLenis";
import { CookieConsentBanner } from "@/components/layout";
import Router from "@/Router";
import { useEffect, useState } from "react";

const App = () => {
  useLenis();

  const [shouldReduceMotion, setShouldReduceMotion] = useState(false);

  useEffect(() => {
    // Disable animations on mobile for better performance
    const isMobile =
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;
    setShouldReduceMotion(isMobile);
  }, []);

  return (
    <HelmetProvider>
      <LazyMotion features={domAnimation}>
        <MotionConfig reducedMotion={shouldReduceMotion ? "always" : "never"}>
          <CookieConsentBanner />
          <Router />
        </MotionConfig>
      </LazyMotion>
    </HelmetProvider>
  );
};

export default App;
